import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ComparerService {

  constructor() { }

  compare(a, b, isAsc: boolean) {
    // Treat undefined, null, and NaN as nullish for ordering purposes
    const isNullish = (v: any) => v === null || v === undefined || (typeof v === 'number' && isNaN(v));

    // Empty string should sort before non-empty values (but still above nulls)
    const isEmptyString = (v: any) => v === '';

    // Always coerce string representations to numbers when possible
    let aValue = typeof a === 'string' ? this.convertToNumber(a) : a;
    let bValue = typeof b === 'string' ? this.convertToNumber(b) : b;

    // Null / undefined rule: always push to bottom regardless of direction
    const aNull = isNullish(aValue);
    const bNull = isNullish(bValue);
    if (aNull && bNull) return 0; // both nullish => equal
    if (aNull) return 1;          // a goes after b
    if (bNull) return -1;         // b goes after a

    // Handle empty string precedence (empty string comes before non-empty for asc, still before for desc to keep consistent ordering)
    const aEmpty = isEmptyString(aValue);
    const bEmpty = isEmptyString(bValue);
    if (aEmpty && bEmpty) return 0;
    if (aEmpty && !bEmpty) return -1; // empty string before others
    if (!aEmpty && bEmpty) return 1;

    // Numeric compare when both are numbers (after conversion)
    if (typeof aValue === 'number' && typeof bValue === 'number') {
      const diff = aValue - bValue;
      if (diff === 0) return 0;
      return diff * (isAsc ? 1 : -1);
    }

    // Fallback to localeCompare for strings / mixed types
    return String(aValue).localeCompare(String(bValue), undefined, { numeric: true }) * (isAsc ? 1 : -1);
  }

  convertToNumber(str) {
    let newStr = str.replace(/,/g, '');

    if(newStr.includes('%')) {
      return parseFloat(newStr.replace('%', '')) / 100;
    }
    else if(newStr.includes('$')) {
      return parseFloat(newStr.replace('$', ''));
    }
    else if (!isNaN(Number(newStr))) {
      return Number(newStr);
    }
    else {
      return str;
    }
  }
}
